import React, {Component} from "react";
import FullScreenImage from "./FullScreenImage";

import imageSrc from './imgs/TV_COL.jpg';

class WelcomeTescoCz extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return <FullScreenImage {...this.state} imgSrc={imageSrc} {...this.props}/>
    }
}

export default WelcomeTescoCz;
